/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timelineloadingmsg2Inputs */

const en_timelineloadingmsg2 = /** @type {(inputs: Timelineloadingmsg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading timeline…`)
};

const pt_timelineloadingmsg2 = /** @type {(inputs: Timelineloadingmsg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar a cronologia…`)
};

/**
* | output |
* | --- |
* | "Loading timeline…" |
*
* @param {Timelineloadingmsg2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const timelineloadingmsg2 = /** @type {((inputs?: Timelineloadingmsg2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timelineloadingmsg2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_timelineloadingmsg2(inputs)
	return pt_timelineloadingmsg2(inputs)
});
export { timelineloadingmsg2 as "timelineLoadingMsg" }